import React from 'react';
import styles from './styles/styles.module.scss';
import { useSelector } from 'react-redux';
import { AlgoliaMemberSearchBox } from '../../../../application/javascripts/react_components/search/algolia_member_search_box';

const CommunityUserConnectionSearch = () => {
  const { context } = useSelector(state => state);

  return (
    <div className={styles.container}>
      <AlgoliaMemberSearchBox {...context} formClass={styles.formClass} />
    </div>
  );
};

export default CommunityUserConnectionSearch;
